import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrintService } from 'app/shared/services/print.service';
import { SelectListItemModel } from 'app/shared/models/select-list-item.model';
import { StageComponent } from '../stage/stage.component';
import { SummaryStageComponent } from '../summary-stage/summary-stage.component';

@Component({
  selector: 'app-print-layout',
  templateUrl: './print-layout.component.html',
  styleUrls: ['./print-layout.component.css']
})
export class PrintLayoutComponent implements OnInit {

  constructor(route: ActivatedRoute,
    private printService: PrintService) {}

  ngOnInit() {     
      // this.printService.onDataReady();
  }
  
}


// WEBPACK FOOTER //
// ./src/app/stages/print-layout/print-layout.component.ts